import Wrapper from "./Wrapper";

const CancellationPolicy = () => {
  return (
    <Wrapper seoTitle="Cancellation Policy">
      <div className="content_inner">
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio
          nesciunt itaque assumenda libero, delectus odit vitae ullam adipisci.
          Architecto sapiente nulla explicabo harum voluptas voluptatibus,
          repudiandae iure deserunt? Deserunt debitis reiciendis fugit quaerat a
          tenetur quam voluptatum quas iusto dolorum voluptas perspiciatis nobis
          nulla delectus id sequi minus asperiores sit, repellendus beatae hic
          quibusdam recusandae atque. Incidunt modi ad minus neque inventore
          ducimus vero quisquam recusandae dolores assumenda aliquid amet nemo
          dolorem necessitatibus, similique laboriosam excepturi quidem unde
          dignissimos accusantium maxime itaque veniam! Ducimus iusto sunt
          voluptas earum eius excepturi labore fuga ullam dolor aliquid
          voluptatibus assumenda, quidem magni? Dicta!
        </p>
      </div>
    </Wrapper>
  );
};

export default CancellationPolicy;
